import * as THREE from 'three';

const EPSILON = 0.00001;
export class Line2 {

    start: THREE.Vector2;
    end: THREE.Vector2;

    constructor(start: THREE.Vector2, end: THREE.Vector2) {
        this.start = start.clone();
        this.end = end.clone();
    }

    public distance(): number {
        return this.start.distanceTo(this.end);
    }

    public delta(target: THREE.Vector2) {
        return target.subVectors(this.end, this.start);
    }

    public midpoint(): THREE.Vector2 {
        const x = this.start.x + (this.end.x - this.start.x) * 0.5;
        const y = this.start.y + (this.end.y - this.start.y) * 0.5;
        return new THREE.Vector2(x, y);
    }

    //線分と線分の交点
    // public crossPoint(line1 : Line2, line2 : Line2) : THREE.Vector2 | null {
    public crossPoint(line: Line2): THREE.Vector2 | null {

        const s1 = ((line.end.x - line.start.x) * (this.start.y - line.start.y) - (line.end.y - line.start.y) * (this.start.x - line.start.x)) * 0.5;
        const s2 = ((line.end.x - line.start.x) * (line.start.y - this.end.y) - (line.end.y - line.start.y) * (line.start.x - this.end.x)) * 0.5;
        const t = s1 / (s1 + s2);

        if (t + EPSILON < 0 || t - EPSILON > 1) return null;

        const x = this.start.x + (this.end.x - this.start.x) * t;
        const y = this.start.y + (this.end.y - this.start.y) * t;
        return new THREE.Vector2(x, y);
    }
}
